import { render, staticRenderFns } from "./lab_result.vue?vue&type=template&id=3e88cbc0&scoped=true&"
import script from "./lab_result.vue?vue&type=script&lang=js&"
export * from "./lab_result.vue?vue&type=script&lang=js&"
import style0 from "./lab_result.vue?vue&type=style&index=0&id=3e88cbc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88cbc0",
  null
  
)

export default component.exports